"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var tooltip_1 = __importDefault(require("../../../plugins/tooltip"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
exports.default = (function (_a) {
    var qualifiesForFreeShipping = _a.qualifiesForFreeShipping, minPriceForFreeShipping = _a.minPriceForFreeShipping, totalBundlePrice = _a.totalBundlePrice, shippingAsterisk = _a.shippingAsterisk, shippingToolTipText = _a.shippingToolTipText, qualifiesForFreeShippingText = _a.qualifiesForFreeShippingText;
    return (React.createElement("div", { className: 'padding-top-6 padding-horizontal-4 medium-padding-horizontal-6' },
        qualifiesForFreeShipping ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'padding-right-3', role: 'img', "aria-label": 'tada' }, "\uD83C\uDF89"),
            qualifiesForFreeShippingText)) : (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'padding-right-3', role: 'img', "aria-label": 'package' }, "\uD83D\uDCE6"),
            "You're ",
            (0, format_price_1.default)(minPriceForFreeShipping - totalBundlePrice),
            " away from free shipping*")),
        React.createElement("div", { className: 'text-nobel padding-bottom-2' },
            React.createElement("span", { className: 'padding-right-1' }, "*"),
            React.createElement("span", { className: 'font-size-small' }, shippingAsterisk),
            React.createElement(tooltip_1.default, { button: React.createElement("i", { className: 'ss-info padding-left-2', style: { verticalAlign: 'middle' } }) },
                React.createElement("div", { className: 'padding-4' },
                    React.createElement("span", null, shippingToolTipText))))));
});
